<template>
  <div v-if="loaded">
    <div class="bg-slate-900 py-4 px-8 flex items-center justify-between flex-wrap">
      <div class="flex items-center justify-center text-white">
        <Logo />
      </div>

      <div class="flex justify-between gap-8">
        <div class="text-sm text-slate-300">
          Step {{ stepNumber + 1 }} of {{ steps.length }} - {{ currentStep.label }}
        </div>
        <div class="flex items-center justify-between gap-6 text-white">
          <StepIndicator
            v-for="(step, index) in steps"
            :key="`stepIndicator.${index}`"
            :current-step-number="stepNumber"
            :step-number="index"
          />
        </div>
      </div>
    </div>
    <div class="py-24 px-6 max-w-3xl mx-auto text-center">
      <component
        :is="currentStep.component"
        :existing-data="onboardingData"
        @go-forward="stepNumber += 1"
        @go-back="stepNumber -= 1"
      />
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import Logo from '../components/hummer/onboarding/Navbar/Logo.vue';
import StepIndicator from '../components/onboarding/StepIndicator.vue';
import CompanyStep from '../components/onboarding/steps/Company.vue';
import ConnectCalendarStep from '../components/onboarding/steps/ConnectCalendar.vue';
import ProfileStep from '../components/onboarding/steps/Profile.vue';

export default {
  components: {
    StepIndicator,
    Logo,
  },
  data() {
    return {
      loaded: false,
      onboardingData: {},
      stepNumber: 0,
    };
  },
  computed: {
    ...mapState({ currentUserAccountDetails: state => state.general.currentUserAccountDetails }),
    steps() {
      if (this.currentUserAccountDetails.onboardingPath === 'team_owner') {
        return [
          {
            name: 'profile',
            label: 'Profile',
            component: ProfileStep,
          },
          {
            name: 'company',
            label: 'Company',
            component: CompanyStep,
          },
          {
            name: 'calendar',
            label: 'Connect Calendar',
            component: ConnectCalendarStep,
          },
        ];
      } else {
        return [
          {
            name: 'profile',
            label: 'Profile',
            component: ProfileStep,
          },
          {
            name: 'calendar',
            label: 'Connect Calendar',
            component: ConnectCalendarStep,
          },
        ];
      }
    },
    currentStep() {
      return this.steps[this.stepNumber];
    },
  },
  async mounted() {
    await this.$store.dispatch('general/loadCurrentUserAccountDetails');
    document.body.classList.remove('lg:overflow-hidden');
    this.loaded = true;
  },
};
</script>

<style>
@reference "tailwindcss";
.spinner {
  height: 22px;
  width: 22px;
  animation: rotateSpinner 0.8s infinite linear;
  border: 2px solid black;
  border-right-color: transparent;
  border-radius: 50%;
}

@keyframes rotateSpinner {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

h2 {
  margin-top: 24px;
}

.formulate-input-element.formulate-input-element--text input,
.formulate-input-element.formulate-input-element--tel input,
.formulate-input-element.formulate-input-element--date input,
.formulate-input-element.formulate-input-element--select select {
  @apply rounded-lg border-2 border-gray-200 w-full max-w-xl;
}

.formulate-input-wrapper {
  @apply my-8;
}
</style>
